// TODO: Autodetect preferred data storage.

let DATA = new Map();

/**
 * @class
 * @classdesc Хранилище данных.
 * @memberOf module:storage
 * @example <caption>Пример реализации своей логики хранения данных</caption>
 * const API_URL = 'http://example.com/api';
 * class MyRemoteStorage extends BaseStorage {
 *
 *     get async() {
 *         return true;
 *     }
 *
 *     load(callback = null) {
 *         let url = `${API_URL}?key=${this.key}`;
 *         get(url, function(data){
 *             callback(data);
 *         });
 *     }
 *
 *     save(data, callback = null) {
 *         let url = `${API_URL}?key=${this.key}&data=${data}`;
 *         post(url, function(data){
 *             callback(data);
 *         });
 *     }
 * }
 *
 * APP.storage = new MyRemoteStorage(dataKey);
 */
class BaseStorage {

    /**
     * Базовый класс хранилища данных. Хранит данные в локальной переменной в течении сессии.
     * Сам по себе этот класс только описывает интерфейс для классов, реализующих более конкретные методы хранения данных, однако его можно использовать в целях отладки или в качестве заглушки.
     * В реальных проектах используйте {@link module:storage.CookieStorage CookieStorage}, {@link module:storage.LocalStorage LocalStorage}, либо наследуйте этот класс для реализации собственной логики хранения данных.
     *
     * @constructor
     * @param {string} key Идентификатор данных в хранилище
     */
    constructor(key) {
        this.key = key;
    }

    /**
     * @member {boolean} module:storage.BaseStorage#available Доступность хранилища
     * @readonly
     */
    get available() {
        return true;
    }

    /**
     * @member {boolean} module:storage.BaseStorage#async Хранилище работает асинхронно. Это значение никак не должно влиять на логику работы хранилища. С его помощью разработчик может ориентироваться, может ли он получить данные синхронно с помощью данного хранилища, или должен использовать callback функцию.
     * @readonly
     */
    get async() {
        return false;
    }

    /**
     * Получение данных с указанным ключом.
     * @param {function} [callback=null] Для асинхронной загрузки. Как параметр получает сохраненные данные.
     * @returns {string} Сериализованные данные (только для синхронных хранилищ)
     */
    load(callback = null) {
        let data = DATA.get(this.key);
        if (callback instanceof Function) {
            callback(data);
        }
        return data;
    }

    /**
     * Сохранение данных с указанным ключом
     * @param {string} data Сериализованные в строку данные.
     * @param {function} [callback=false] Вызывается после того как данные сохранились
     */
    save(data, callback = null) {
        DATA.set(this.key, data);
        if (callback instanceof Function) {
            callback();
        }
    }
}

export default BaseStorage;